<template>
    <div>
        <multiselect v-model="DisplayValue" :options="options" :multiple="false" placeholder="Select Patient"
            track-by="id" :clear-on-select="false" :show-labels="false" label="name" :preselect-first="true">
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'patientDropdown',
    props: ['modelValue'],
    components: {
        Multiselect,
    },
    data() {
        return {
            options: [],
            value: ''
        };
    },
    computed: {
        DisplayValue: {
            get() {
                // Return a safe fallback if both value and modelValue are null
                return this.value || this.modelValue || null;
            },
            set(value) {
                if (value && value.id) {
                    // Assign the value and emit the id if valid
                    this.value = value;
                    this.$emit('update:modelValue', value.id);
                } else {
                    // Handle null/undefined case
                    this.value = null;
                    this.$emit('update:modelValue', null);
                }
            },
        },
    },
    methods: {
        getData: function () {
            var root = this;
            var token = '';
            if (token == '') {
                token = localStorage.getItem('token');
            }

            this.$https.get('/Account/GetPatientList?isDropDown=true', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                if (response.data != null) {
                    response.data.data.results.forEach(function (cat) {

                        root.options.push({
                            id: cat.id,
                            name: cat.fullName + " " + cat.insuranceNumber
                        })
                    })
                }
            })
            .then(() => {
                // Find the matching option or set to null if not found
                this.value = this.options.find((x) => x.id == this.modelValue) || null;
            })
            .catch((error) => {
                    console.error("Error fetching family list:", error);
                });
            },

    },
    mounted: function () {
        this.getData();
    },
}
</script>